module.exports = __webpack_public_path__ + "static/media/registry-video@2x.7d6c8e52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/registry-video@2x.jpg
// module id = 1405
// module chunks = 46